module.exports = __webpack_public_path__ + "6bbe8143e5d988ecc07638ae8f812dbb.svg";